import Page from "@modul-connect/shared/components/atoms/page"
import View from "@modul-connect/shared/components/atoms/view"
import TableWidget from "@modul-connect/shared/components/molecules/tableWidgetv2"
import { ModalCreateMessage } from "./modalCreateMessage"
import { useEffect, useMemo, useState } from "react"
import { connect } from "react-redux"
import { createDisturbanceMessage, endDisturbanceMessage, fetchDisturbanceMessages } from "../../../state/actions/customers"
import { formatDisturbanceDateTime } from "@modul-connect/shared/utils/dateTimeUtils"
import { formatListWithLabels } from "@modul-connect/shared/utils/text"
import { resetCreateDisturbance } from "../../../state/actions/customers"

export const DisturbancePage = ({ createDisturbanceMessage, resetCreateDisturbance, saving, disturbance, endDisturbanceMessage, fetchDisturbanceMessages, loading }) => {
  
  const [openModal, setOpenModal] = useState(false)
    
  const visibleForLabels = { technician: "Technician", endUser: "End user" }
  const domainLabels = { app: "App", portal: "Portal" }
  
  const disturbanceData = useMemo(() => {
    const raw = disturbance?.data ?? []
    const prepared = raw.map((row) => ({
      ...row,
      visibleForDisplay: formatListWithLabels(row.visibleFor, visibleForLabels),
      domainDisplay: formatListWithLabels(row.domain, domainLabels),
      startingAtDisplay: formatDisturbanceDateTime(row.startingAt),
      endingAtDisplay: formatDisturbanceDateTime(row.endingAt),
      status: row.closed === false ? "Active" : "Resolved",
    }))
    return prepared.sort((a, b) => {
      if (a.status !== b.status) {
        return a.status === "Active" ? -1 : 1
      }
      if (a.status !== "Active") {
        const aEnd = new Date(a.endingAt || 0).getTime()
        const bEnd = new Date(b.endingAt || 0).getTime()
        return bEnd - aEnd
      }
      return 0
    })
  }, [disturbance?.data])

const columns = [
    {
      id: 'title',
      label: 'Title',
      hide: []
    },
    {
      id: 'visibleForDisplay',
      label: 'Visible for',
      hide: []
    },
    {
      id: 'domainDisplay',
      label: 'Platform',
      hide: []
    },
    {
      id: 'startingAtDisplay',
      label: 'Started at',
      hide: []
    },
    {
      id: 'endingAtDisplay',
      label: 'Ending at',
      hide: []
    },
    {
      id: 'status',
      label: 'Status',
      hide: []
    },
  ]
  
  useEffect(() => {
    if (saving.createDisturbance === null) {
      setOpenModal(false);
    }
    }, [saving]);

  const handleOpenModal = () => {
    resetCreateDisturbance()
    setOpenModal(true)
  }
  const handleCloseModal = () => {
    setOpenModal(false)
    resetCreateDisturbance()
  }

  return (
    <View>
      <Page title='Disturbance message' linkTitle='Add message' onClickLink={handleOpenModal}
        >
      <TableWidget
        data={disturbanceData}
        loadingStatus={loading.fetchMessages}
        onFetchData={fetchDisturbanceMessages}
        columns={columns}
        customRowButton={{
          label: 'End disturbance',
          visible: (row) => row.status === "Active",
          onClick: (event, rowId, row) => {
            endDisturbanceMessage({ id: row.id })
          },
        }}
      />

    </Page>
    <ModalCreateMessage saving={saving} openModal={openModal} onClose={handleCloseModal} onCreateMessage={createDisturbanceMessage} />
    </View>
  )
}

const mapStateToProps = ({ saving, disturbance, loading }) => ({
  saving,
  disturbance,
  loading
})

const mapDispatchToProps = dispatch => ({
  createDisturbanceMessage: data => dispatch(createDisturbanceMessage(data)),
  endDisturbanceMessage: data => dispatch(endDisturbanceMessage(data)),
  fetchDisturbanceMessages: data => dispatch(fetchDisturbanceMessages(data)),
  resetCreateDisturbance: () => dispatch(resetCreateDisturbance()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DisturbancePage);
